export default __webpack_public_path__ + "assets/images/3581edbdc310361e28907fc078e4a71f.png";